/* ============================================================
   CUSTOM PRODUCT PAGE — geconsolideerde JS
   Auto-gegenereerd uit custom-liquid blokken in product.json + index.json.
   Elk blok is gewrapt in een IIFE om naam-collisions te voorkomen.
   ============================================================ */
/* ----- product / block custom_liquid_D8MBqH ----- */
(function(){
(function () {
    // De-dupliceer modals (themes renderen soms dubbel voor desktop + mobiel)
    var allModals = document.querySelectorAll('.reluxa-size-modal');
    for (var i = 1; i < allModals.length; i++) {
      allModals[i].remove();
    }

    var modal = document.querySelector('.reluxa-size-modal');
    if (!modal) return;

    // Verplaats modal naar body — voorkomt dat parent-elementen
    // met transform/filter/perspective de "position: fixed" breken
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    var openers = document.querySelectorAll('[data-reluxa-size-open]');
    var closers = modal.querySelectorAll('[data-reluxa-size-close]');
    var scrollY = 0;

    function open() {
      scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.width = '100%';
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
    }
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollY);
    }

    openers.forEach(function (el) { el.addEventListener('click', open); });
    closers.forEach(function (el) { el.addEventListener('click', close); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  })();
})();

/* ----- product / block custom_liquid_TUjEx4 ----- */
(function(){

})();

/* ----- product / block custom_liquid_TUjEx4 ----- */
(function(){
(function() {
  function init() {
    if (typeof Swiper === 'undefined') { setTimeout(init, 50); return; }

    var photoSwiper = new Swiper('.review-photo-slider', {
      slidesPerView: 3,
      spaceBetween: 8,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      breakpoints: {
        749: { slidesPerView: 5, spaceBetween: 10 },
        1100: { slidesPerView: 6, spaceBetween: 12 }
      }
    });

    new Swiper('.review-content-slider', {
      slidesPerView: 1,
      spaceBetween: 16,
      thumbs: { swiper: photoSwiper }
    });
  }
  init();
})();
})();

/* ----- product / section custom_liquid_THEeBX ----- */
(function(){
(function() {
  var video = document.querySelector('.vak-feature-full__video');
  if (!video) return;

  // muted is verplicht voor autoplay — afdwingen via property
  video.muted = true;
  video.defaultMuted = true;

  function tryPlay() {
    var p = video.play();
    if (p !== undefined) {
      p.catch(function() { /* stil falen: volgende trigger probeert opnieuw */ });
    }
  }

  // Loop-fallback: niet alle browsers respecteren het loop-attribuut betrouwbaar
  video.addEventListener('ended', function() {
    video.currentTime = 0;
    tryPlay();
  });

  // Stalls / buffer-onderbrekingen
  ['stalled', 'suspend', 'pause'].forEach(function(evt) {
    video.addEventListener(evt, function() {
      // alleen hervatten als de video in beeld is en niet bewust gepauzeerd
      if (!document.hidden && isInViewport(video)) {
        setTimeout(tryPlay, 200);
      }
    });
  });

  // Tab weer actief
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) tryPlay();
  });

  function isInViewport(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
  }

  // Pas afspelen als 'ie in beeld komt (spaart data + voorkomt 'verloren' eerste play)
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          tryPlay();
        }
      });
    }, { threshold: 0.15 });
    io.observe(video);
  } else {
    tryPlay();
  }
})();
})();

/* ----- product / section custom_liquid_XCHbn4 ----- */
(function(){
(function() {
    var BATCH_SIZE = 8;
    var grid = document.getElementById('reviewx-grid');
    var template = document.getElementById('reviewx-template');
    var btn = document.getElementById('reviewx-load-more');
    var btnWrap = document.getElementById('reviewx-load-more-wrap');

    if (!grid || !template || !btn) return;

    var allCards = Array.prototype.slice.call(template.querySelectorAll('.reviewx-card'));
    var shown = 0;
    var currentColCount = 0;
    var columns = [];

    function getColCount() {
      return window.matchMedia('(min-width: 800px)').matches ? 3 : 2;
    }

    function buildColumns(n) {
      grid.innerHTML = '';
      columns = [];
      for (var i = 0; i < n; i++) {
        var col = document.createElement('div');
        col.className = 'reviewx-column';
        grid.appendChild(col);
        columns.push(col);
      }
      currentColCount = n;
    }

    function renderRange(start, end) {
      for (var i = start; i < end; i++) {
        getShortestColumn().appendChild(allCards[i].cloneNode(true));
      }
    }

    function getShortestColumn() {
      var shortest = columns[0];
      var minHeight = shortest.offsetHeight;
      for (var i = 1; i < columns.length; i++) {
        if (columns[i].offsetHeight < minHeight) {
          minHeight = columns[i].offsetHeight;
          shortest = columns[i];
        }
      }
      return shortest;
    }

    function init() {
      buildColumns(getColCount());
      var initial = Math.min(BATCH_SIZE, allCards.length);
      renderRange(0, initial);
      shown = initial;
      updateButton();
    }

    function showMore() {
      var next = Math.min(shown + BATCH_SIZE, allCards.length);
      renderRange(shown, next);
      shown = next;
      updateButton();
    }

    function updateButton() {
      if (shown >= allCards.length) {
        btnWrap.style.display = 'none';
      }
    }

    function rebuildOnResize() {
      var newCount = getColCount();
      if (newCount !== currentColCount) {
        buildColumns(newCount);
        renderRange(0, shown);
      }
    }

    init();

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      showMore();
    });

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(rebuildOnResize, 150);
    });
  })();
})();
